<template>
  <div class="entry">
    <div class="error">
      <div class="error_bg">
        <div class="error_inner">
          <h1 class="error_title">404</h1>
          <h4 class="error_subtitle">{{ $t('title.notFound') }}</h4>
          <h4 class="error_subtitle mtop">
            {{ $t('404GetBackToHome') }}
            <router-link :to="lang ? '/' + lang + path + '/' : '/'">
              {{ $t('404GetBackToHomeLink') }}
            </router-link>
          </h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'NotFoundPage',
  metaInfo() {
    return {
      title: this.$t('meta.other.titleTmpl', {
        h1: this.$t('title.notFound'),
      }),
      meta: [
        {
          name: 'robots',
          content: 'noindex, follow',
        },
        {
          name: 'description',
          content: this.$t('meta.other.descriptionTmpl', {
            h1: this.$t('title.notFound'),
          }),
        },
      ],
    }
  },
  methods: {
    ...mapMutations(['setBreadcrumbs']),
  },
  mounted() {
    this.setBreadcrumbs('')
    this.$h.gtmDataLayerPush({
      ecomm_pagetype: 'other',
    })
  },
}
</script>

<style>
.error .error_inner {
  padding: 50px 20px 50px;
}

.error_inner .error_subtitle.mtop {
  margin-top: 20px;
}

.error_inner .error_subtitle.mtop a {
  color: rgba(76, 118, 161, 0.9);
}

.error_inner .error_subtitle.mtop a:hover {
  color: rgba(255, 68, 0, 0.9);
}
</style>
